import { saveAs } from 'file-saver';

import { deletePerformanceFile, getPerformanceFile, postPerformanceFile } from 'api/performanceAPI';
import { handleError } from 'services/Error';

/* Performance files */

export const downloadPerformanceFile = async ({
    npi,
    filename,
    referralId,
    conditionId,
}: {
    npi: string;
    filename: string;
    referralId: string;
    conditionId: string;
}) => {
    try {
        saveAs(await getPerformanceFile({ npi, referralId, conditionId, filename }), filename);
    } catch (err) {
        handleError(`An error occurred downloading ${filename}.`, err as Error);
    }
};

export const uploadPerformanceFiles = async ({
    files,
    npi,
    referralId,
    conditionId,
}: {
    files: File[];
    npi: string;
    referralId: string;
    conditionId: string;
}) => {
    try {
        await Promise.all(
            files.map(async (file) => postPerformanceFile({ npi, referralId, conditionId, file })),
        );
    } catch (err) {
        handleError('An error occurred uploading files.', err as Error);
        throw err; // Propagate error to FileUpload component
    }
};

export const removePerformanceFile = async ({
    filename,
    npi,
    referralId,
    conditionId,
}: {
    filename: string;
    npi: string;
    referralId: string;
    conditionId: string;
}) => {
    try {
        await deletePerformanceFile({ npi, referralId, conditionId, filename });
    } catch (err) {
        handleError(`An error occurred deleting ${filename}.`, err as Error);
        throw err; // Propagate error to FileUpload component
    }
};
